import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { PrismicNextLink } from '@prismicio/next';
import {
  LoanUsesSliceCarouselPrimaryCardsItem,
  Simplify,
} from '../../../../../../../prismicio-types';
import { AnimateLinkText, OptimizedPrismicImage } from '@/components';
import styles from './loanUsesCard.module.scss';
import { useVisible } from '@/hooks';

interface LoanUsesCardProps {
  item: Simplify<LoanUsesSliceCarouselPrimaryCardsItem>;
  variant: 'desktop' | 'mobile';
  index: number;
}

const components: JSXMapSerializer = {
  heading4: ({ children }) => <h4 className={styles.heading}>{children}</h4>,
};
export const LoanUsesCard = ({ item, variant, index }: LoanUsesCardProps) => {
  const variantStyle = styles[variant];
  const [isVisible, id] = useVisible();

  return (
    <PrismicNextLink
      field={item.link}
      key={item.description}
      className={`${styles.card} ${variantStyle} ${isVisible && variant === 'mobile' ? styles.isVisible : ''}`}
      id={id}
      style={{
        transitionDelay: `${variant === 'desktop' ? index * 0.13 : 0}s`,
      }}
    >
      <div className={`${styles.text_wrapper} ${variantStyle}`}>
        <div>
          <PrismicRichText field={item.heading} components={components} />
          <p className={styles.description}>{item.description}</p>
        </div>
        <AnimateLinkText text={item.link_text as string} styles={styles.text} />
      </div>
      <OptimizedPrismicImage
        field={item.image}
        className={`${styles.image} ${variantStyle}`}
      />
    </PrismicNextLink>
  );
};
